<template>
  <div class="bill">
    <van-sticky>
      <van-nav-bar :border="false">
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.back()"></span>
        </template>
        <template #title>
          <strong>代理账单核对</strong>
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-sticky :offset-top="46">
      <div class="filter flex align-center justify-between">
        <div class="filter-item" @click="show = true">
          <span>{{ filterTime }}</span>
          <van-icon name="arrow-down" class="ml-5" />
        </div>
        <div v-show="isShowAgentBtn" class="filter-btn" @click="toggleBill">切换{{ curBillRule === 'getAgentBillMusic' ? '代理' : '音乐人' }}账单</div>
        <van-action-sheet v-model="show">
          <van-datetime-picker
            v-model="currentDate"
            type="year-month"
            title="选择年月"
            :formatter="formatter"
            confirm-button-text="完成"
            @cancel="show = false"
            @confirm="filter"
          />
        </van-action-sheet>
      </div>
    </van-sticky>
    <van-pull-refresh v-model="isLoading" class="flex-1" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      ><div class="card-list">
        <div v-for="item in music" :key="item.uid" class="mr-card mt-10">
          <div class="title">
            <strong>{{ item.label }}: {{ item.name }}</strong>
            <div class="flex align-center" @click="jumpLink(item)">
                账单明细
                <van-icon name="arrow" class="fs-16 ml-7" />
              </div>
          </div>
          <div class="content">
            <div><strong class="fs-14">收益金额: {{ item.income | formatAmount }}</strong></div>
          </div>
        </div>
        </div>
        <template v-if="music.length > 0" #finished>
          <span>没有更多了</span>
        </template>
        <van-empty v-if="music.length === 0" description="暂无数据" />
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import Filter from '@/filters/index'
import { getAgentBillMusic, getAgentBill, getAgentBillInfo } from '@/api/agent'
export default {
  name: 'AgentBill',
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      show: false,
      currentDate: new Date(), // 日期选择器的时间，实时变化的
      date: '', // 当前显示的筛选的日期
      music: [], // 列表数据
      currentPage: 0,
      isShowAgentBtn: false, // 默认不展示切换代理账单
      curBillRule: 'getAgentBillMusic'
    }
  },
  computed: {
    filterTime() {
      const name = Filter.formatTime(this.date, '{y}-{m}') === Filter.formatTime(new Date(), '{y}-{m}') ? '本月' : Filter.formatTime(this.date, '{y}-{m}')
      return name
    }
  },
  async created() {
    await this.getAgentBill('refresh', 'check')
  },
  methods: {
    async getAgentBillMusic(type) {
      const res = await getAgentBillMusic({ page: this.currentPage, updatetime: Filter.formatTime(this.date, '{y}-{m}') })
      const data = res.data
      this.currentPage = +data.current_page // 隐士转化为Number类型
      const list = data.data.map(val => ({
        label: '直属音乐人',
        name: val.nickname,
        income: val.income,
        to: '/agent/bill-detail?uid=' + val.uaid + '&time=' + Filter.formatTime(this.date, '{y}-{m}')
      }))
      if (type === 'refresh') { // 下拉刷新
        this.music = list
      } else { // 上拉加载
        this.music = [...this.music, ...list]
      }
      return list.length
    },
    async getAgentBillInfo(params) { // 获取直属代理人详情接口
      const res = await getAgentBillInfo(params)
      return res.data
    },
    async toggleBill() {
      try {
        this.$store.commit('TOGGLE_LOADING', true)
        this.curBillRule = this.curBillRule === 'getAgentBillMusic' ? 'getAgentBill' : 'getAgentBillMusic'
        await this[this.curBillRule]('refresh')
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    async jumpLink(item) {
      if (item.to) {
        this.$router.push(item.to)
      } else {
        // 打开弹窗
        this.$store.commit('TOGGLE_LOADING', true)
        try {
          const data = await this.getAgentBillInfo({ agent_id: item.agent_id, updatetime: Filter.formatTime(this.date, '{y}-{m}') })
          this.$dialog.alert({
            title: '账单明细',
            message: `二级代理返佣：${data.money_2}\n三级代理返佣：${data.money_3}`
          })
        } finally {
          this.$store.commit('TOGGLE_LOADING', false)
        }

      }
    },
    async getAgentBill(type, check) {
      const res = await getAgentBill({ page: this.currentPage || 1, updatetime: Filter.formatTime(this.date, '{y}-{m}') })
      const data = res.data
      if (check === 'check') { // 只做显示和隐藏按钮，不做数据展示
        data.total > 0 && (this.isShowAgentBtn = true)
        return
      }
      this.currentPage = +data.current_page
      const list = data.data.map(val => ({
        label: '直属代理',
        name: val.agent_name,
        income: val.total_money,
        agent_id: val.agent_id
      }))
      if (type === 'refresh') {
        this.music = list
      } else {
        this.music = [...this.music, ...list]
      }
      return list.length
    },
    async onRefresh() {
      this.currentPage = 1
      await this.getAgentBillMusic('refresh')
      this.$toast('刷新成功')
      this.isLoading = false
      this.finished = false
    },
    async onLoad() {
      this.loading = true
      this.currentPage = this.currentPage + 1
      const length = await this.getAgentBillMusic()
      if (length < 1) {
        this.finished = true
      }
      this.loading = false
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    async filter(time) {
      this.date = time
      this.show = false
      // 进行请求接口
      try {
        this.$store.commit('TOGGLE_LOADING', true)
        await this.getAgentBillMusic('refresh')
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bill{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: auto;
  /deep/ .van-pull-refresh__track{
    min-height: calc(100vh - 46Px);
  }
}
.card-list{
  padding: 0 15px;
}
.filter{
  padding: 10px 16px;
  background-color: #fff;
  .filter-item{
    display: flex;
    align-items: center;
    padding: 5px 15px;
    border-radius: 5px;
    background-color: #F3F4F6;
  }
  .filter-btn{
    padding: 5px 15px;
    background-color: #F3F4F6;
  }
}
.mr-card{
  font-size: 12px;
  border-radius: 15px;
  box-shadow: 0 0 5px 0 rgb(206, 204, 204);
  .title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    border-bottom: 1px solid #E0E2E7;
    a{
      color: inherit;
    }
  }
  .content{
    padding: 20px 16px 30px;
    .count{
      display: flex;
      flex-wrap: wrap;
      .count-item{
        width: 50%;
        color: #9DA4B3;
        margin-bottom: 6px;
      }
    }
  }
}
</style>
